import { Link } from "react-router-dom";
import {
  HeadingTitle,
  SubHeadingTitle,
  Button,
  Image,
} from "../../../components/shared/index";
import styles from "./aboutus.module.css";
const Store = () => {
  return (
    <>
      <section className={styles.store__wrapper}>
        <div className={styles.textContent}>
          <HeadingTitle
            text={
              <>
                <span className={styles.highlight}> Welcome to GDRB Fashion</span>
                <br />
              </>
            }
            style={styles.heading}
          />

          <SubHeadingTitle
            subTitle={
              <p>
At GDRB Fashion, we are passionate about delivering products that combine comfort, elegance, and affordability. From everyday essentials to statement pieces, each item is selected with attention to detail and a commitment to quality. Our goal is to help you look and feel your best, no matter where life takes you.
Customer satisfaction is at the heart of everything we do. We strive to provide a seamless shopping experience, reliable service, and fashion choices that inspire confidence.
              </p>
            }
          />

          {/* ✅ Move button here */}
          <Link to={"/shop"}>
            <Button
              type="button"
              title={"Shop Now"}
              style={styles.shopBtn}
            />
          </Link>
        </div>

        <div className={styles.imageWrapper}>
          <Image
            src="https://img.magnific.com/free-photo/full-length-portrait-young-family_171337-2282.jpg?w=1500"
            className={styles.image}
            alt="Hiraola Jewellery"
          />
        </div>
      </section>
    </>
  );
};
export default Store; 
